import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FuseLoginTwoPageComponent } from '@mobileia/layout-fuse';
import { fuseLoginConfig } from './system/fuse-config';
import { AuthGuard } from '@mobileia/authentication';
import { SystemComponent } from './system/system.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { SliderComponent } from './pages/slider/slider.component';
import { SliderAddComponent } from './pages/slider-add/slider-add.component';
import { CategoryComponent } from './pages/category/category.component';
import { CategoryAddComponent } from './pages/category-add/category-add.component';
import { ProductComponent } from './pages/product/product.component';
import { ProductAddComponent } from './pages/product-add/product-add.component';
import { ProductRelatedComponent } from './pages/product-related/product-related.component';
import { TransactionComponent } from './pages/transaction/transaction.component';
import { TransactionViewComponent } from './pages/transaction-view/transaction-view.component';
import { SectionComponent } from './pages/section/section.component';
import { SectionEditFourComponent } from './pages/section-edit-four/section-edit-four.component';
import { HelpboxComponent } from './pages/helpbox/helpbox.component';
import { HelpboxAddComponent } from './pages/helpbox-add/helpbox-add.component';
import { PagetagComponent } from './pages/pagetag/pagetag.component';
import { PagetagAddComponent } from './pages/pagetag-add/pagetag-add.component';
import { SectionEditOneComponent } from './pages/section-edit-one/section-edit-one.component';
import { SectionEditTwoComponent } from './pages/section-edit-two/section-edit-two.component';
import { SectionEditThreeComponent } from './pages/section-edit-three/section-edit-three.component';
import { PaymentDiscountComponent } from './pages/payment-discount/payment-discount.component';
import { PaymentDiscountAddComponent } from './pages/payment-discount-add/payment-discount-add.component';
import { PaymentInstallmentComponent } from './pages/payment-installment/payment-installment.component';
import { PaymentInstallmentAddComponent } from './pages/payment-installment-add/payment-installment-add.component';
import { SectionEditFiveComponent } from './pages/section-edit-five/section-edit-five.component';
import { ProductDiscountComponent } from './pages/product-discount/product-discount.component';
import { ProductDiscountAddComponent } from './pages/product-discount-add/product-discount-add.component';
import { SynonymGroupComponent } from './pages/synonym-group/synonym-group.component';
import { SynonymGroupAddComponent } from './pages/synonym-group-add/synonym-group-add.component';

const routes: Routes = [
  {
    path: '',
    component: SystemComponent,
    canActivate: [AuthGuard],
    children: [
      /*{
        path: 'dashboard',
        component: DashboardComponent
      },*/

      {
        path: 'slider',
        component: SliderComponent
      },
      {
        path: 'slider-add',
        component: SliderAddComponent
      },
      {
        path: 'slider-edit/:id',
        component: SliderAddComponent
      },

      {
        path: 'category',
        component: CategoryComponent
      },
      {
        path: 'category-add',
        component: CategoryAddComponent
      },
      {
        path: 'category-edit/:id',
        component: CategoryAddComponent
      },

      {
        path: 'product',
        component: ProductComponent
      },
      {
        path: 'product-add',
        component: ProductAddComponent
      },
      {
        path: 'product-edit/:id',
        component: ProductAddComponent
      },
      {
        path: 'product-related/:id',
        component: ProductRelatedComponent
      },

      {
        path: 'transaction',
        component: TransactionComponent
      },
      {
        path: 'transaction-view/:id',
        component: TransactionViewComponent
      },

      {
        path: 'section',
        component: SectionComponent
      },
      {
        path: 'section-view/1',
        data: {
          id: 1
        },
        component: SectionEditOneComponent
      },
      {
        path: 'section-view/2',
        data: {
          id: 2
        },
        component: SectionEditTwoComponent
      },
      {
        path: 'section-view/3',
        data: {
          id: 3
        },
        component: SectionEditThreeComponent
      },
      {
        path: 'section-view/4',
        data: {
          id: 4
        },
        component: SectionEditFourComponent
      },
      {
        path: 'section-view/5',
        data: {
          id: 5
        },
        component: SectionEditFiveComponent
      },

      {
        path: 'helpbox',
        component: HelpboxComponent
      },
      {
        path: 'helpbox-edit/:id',
        component: HelpboxAddComponent
      },

      {
        path: 'pagetag',
        component: PagetagComponent
      },
      {
        path: 'pagetag-edit/:id',
        component: PagetagAddComponent
      },

      {
        path: 'payment-discount',
        component: PaymentDiscountComponent
      },
      {
        path: 'payment-discount-add',
        component: PaymentDiscountAddComponent
      },
      {
        path: 'payment-discount-edit/:id',
        component: PaymentDiscountAddComponent
      },

      {
        path: 'payment-installment',
        component: PaymentInstallmentComponent
      },
      {
        path: 'payment-installment-add',
        component: PaymentInstallmentAddComponent
      },
      {
        path: 'payment-installment-edit/:id',
        component: PaymentInstallmentAddComponent
      },

      {
        path: 'product-discount',
        component: ProductDiscountComponent
      },
      {
        path: 'product-discount-add',
        component: ProductDiscountAddComponent
      },
      {
        path: 'product-discount-edit/:id',
        component: ProductDiscountAddComponent
      },

      {
        path: 'synonym-group',
        component: SynonymGroupComponent
      },
      {
        path: 'synonym-group-add',
        component: SynonymGroupAddComponent
      },
      {
        path: 'synonym-group-edit/:id',
        component: SynonymGroupAddComponent
      },
    ]
  },
  {
    path: 'login',
    component: FuseLoginTwoPageComponent,
    data: {
      config: fuseLoginConfig
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
